<template>
  <div class="flex-grid summer-data-blocks" :class="{ 'news-present-too' : newsPresent }">
    <customOverviewSection :mountainAreas="downhillAreas" :areaName="trailsOverviewNames['Downhill']"  v-if="showDownhillBikesOpenBlock"/>
    <customOverviewSection v-for="trailOverviewBlock in summerTrailsOverviewBlocks" :mountainAreas="mountainAreas" :key="trailOverviewBlock" :areaName="trailsOverviewNames[trailOverviewBlock] || trailOverviewBlock" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import customOverviewSection from '@/components/Summer/customOverviewSection.vue';

export default {
  components: {
    customOverviewSection,
  },
  name: 'OverviewSections',
  props: ['newsPresent'],
  computed: {
    ...mapState(['trailsOverviewBlocks', 'summerTrailsOverviewBlocks', 'trailsOverviewNames', 'mountainAreas']),
    showDownhillBikesOpenBlock() {
      return this.trailsOverviewBlocks.indexOf('DownhillBikesInfo') >= 0;
    },
    downhillAreas() {
      if (this.mountainAreas) {
        return this.mountainAreas.filter(area => area.Name === 'Downhill Biking' || area.Name === 'Downhill' || area.Name === 'Mountain Biking');
      }
    },
    openMountainBike() {
      if (this.downhillAreas) {
        return this.downhillAreas[0].OpenTrailsCount;
      }
      return '0';
    },
    totalMountainBike() {
      if (this.downhillAreas) {
        return this.downhillAreas[0].TotalTrailsCount;
      }
      return '0';
    },
  },
};
</script>

<style lang="scss" scoped>
.summer-data-blocks {
  flex-basis: 100%;
  &.news-present-too {
    flex-basis: 100%;
  }
  @media (min-width: $tablet) {
    flex-basis: 75%;
    &.news-present-too {
      flex-basis: 65%;
    }
  }
}
</style>
